import { z } from 'zod';
import {
  notificationStatusEnumSchema,
  notificationTypeEnumSchema,
  parentTableEnumSchema,
} from '../../shared/enums';

export const notificationCreateDataSchema = z.object({
  userIds: z.array(z.string().uuid()).min(1),
  type: z.enum(notificationTypeEnumSchema.options).default('info'),
  title: z.string().max(255),
  description: z.string().optional(),
  status: z.enum(notificationStatusEnumSchema.options).default('new'),
  parentTable: z
    .enum(parentTableEnumSchema.options)
    .default('contacts')
    .nullable(),
  parentRecordId: z.string().length(36).nullable(),
});

export type NotificationCreateData = z.infer<
  typeof notificationCreateDataSchema
>;
